var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"hiq-calendar"},[_c('filters'),_c('search-info'),_c('events'),_c('loader'),_c('load-more')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }